import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalService } from '../../dialogs/modal/modal.service';
import { CoreLibLinkConfirmationModalComponent } from '../../dialogs/link-confirmation-modal/link-confirmation-modal.component';
import { take } from 'rxjs/operators';

@Component({
    selector: 'mh-core-lib-origins-preview-dropdown',
    templateUrl: './origins-preview-dropdown.component.html',
    styleUrls: ['./origins-preview-dropdown.component.scss'],
    standalone: false
})
export class CoreLibOriginsPreviewDropdownComponent {
  @Input()
  originsUrls: { name: string; url: string; active: boolean }[] = [];

  @Input()
  show = true;

  @Output()
  previewOpened = new EventEmitter<string>();

  isOpen = false;

  constructor(private modalService: ModalService) {}

  handleOpenPreview(url: string, originName: string) {
    this.closeDropdown();

    const config = {
      data: {
        linkName: originName,
        url: url,
        modalType: 'link',
      },
    };

    const classes = ['overlay-panel', 'fit-height-content'];

    const confirmDialog = this.modalService.open(CoreLibLinkConfirmationModalComponent, config, classes);

    confirmDialog
      .afterClosed()
      .pipe(take(1))
      .subscribe((result) => {
        if (result === 'OPEN') {
          window.open(url, '_blank');
          this.previewOpened.emit(url);
        }

        if (result === 'CANCEL') {
          window.open(url + '&demo=true', '_blank');
        }
      });
  }

  toggleDropdown() {
    if (this.isBlocked) return;

    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  get activeOriginsUrls() {
    return this.originsUrls?.filter((item) => item.active) || [];
  }

  get hasOriginsUrls() {
    return this.activeOriginsUrls.length > 0;
  }

  get hasAnyOrigins() {
    return (this.originsUrls?.length || 0) > 0;
  }

  get isBlocked() {
    return !this.hasOriginsUrls;
  }

  get tooltipKey() {
    return this.isBlocked ? 'header.tooltips.origins_blocked' : 'header.tooltips.view_links';
  }

  trackByUrl(index: number, item: { name: string; url: string; active: boolean }): string {
    return item.url;
  }
}
